import { DateTimeLocalizationInfo } from '@mews-framework/globalization';
import { createTimeService as createFrameworkTimeService, padStartZero, StructuredTime } from '@optimus-web/core';
import * as DateTimeUtils from '../dateTimeUtils';
import { TimeService } from '../times';

export const createTimeService = ({
    getCurrentDateTimeLocalizationInfo,
}: {
    getCurrentDateTimeLocalizationInfo: () => DateTimeLocalizationInfo;
}) => {
    const getLocalization = () => getCurrentDateTimeLocalizationInfo();
    const getServiceTime = ({ hours, minutes, seconds }: StructuredTime) =>
        TimeService.parse(`${padStartZero(hours)}:${padStartZero(minutes)}:${padStartZero(seconds)}`);
    const getStructuredTime = DateTimeUtils.timeToStructuredTime;

    const getIsoString = (timeValues: StructuredTime) =>
        TimeService.toISOTime({
            time: getServiceTime(timeValues),
            suppressMilliseconds: true,
            includeOffset: false,
        });
    const getString = (timeValues: StructuredTime) =>
        TimeService.toString(getServiceTime(timeValues), getLocalization());
    const getShortString = (timeValues: StructuredTime) =>
        TimeService.toShortString(getServiceTime(timeValues), getLocalization());
    const isValidString = (timeString: string) => TimeService.isValidString(timeString, getLocalization());
    const isValidShortString = (timeString: string) => TimeService.isValidShortString(timeString, getLocalization());
    const fromString = (timeString: string) => getStructuredTime(TimeService.fromString(timeString, getLocalization()));
    const fromShortString = (timeString: string) =>
        getStructuredTime(TimeService.fromShortString(timeString, getLocalization()));
    const fromIsoString = (timeString: string) => TimeService.parse(timeString);

    return createFrameworkTimeService({
        getLocalization,
        getIsoString,
        getString,
        getShortString,
        isValidString,
        isValidShortString,
        // @ts-expect-error $TSFixMeError: Type '(timeString: $TSFixMe) => Time' is not assignable to type '(isoString: string) => StructuredTime'.
        fromIsoString,
        fromString,
        fromShortString,
    });
};
